export default "__VITE_ASSET__81a1c0db__"